import { Modal } from 'ant-design-vue';

export const createConfirmModal = (title, callback) => Modal.confirm({
  title,
  cancelText: 'Отмена',
  okText: 'Подтвердить',
  onOk: callback,
});
